import {authenticated_api} from "./base";
import {isSubscriptionTier} from "../helper/planTierMapping";

const SUBSCRIPTION_BILLING_CYCLES = new Set(["monthly", "annual"]);

export const getSubscriptionStatus = async () => {
  try {
    return await authenticated_api.get(`/subscriptions/status/`);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};

export const getSubscriptionInvoices = async (limit = 20) => {
  try {
    return await authenticated_api.get(
      `/subscriptions/invoices/`,
      {
        params: { limit }
      });
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};

export const getSubscriptionPlanCatalog = async () => {
  try {
    return await authenticated_api.get(`/subscriptions/plans/`);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};

export const cancelSubscription = async (reason = "") => {
  try {
    return await authenticated_api.post(
      `/subscriptions/cancel/`,
      reason ? { reason } : {});
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};

export const adjustSubscriptionPlan = async (tier_id, billing_cycle) => {
  if (
    !isSubscriptionTier(tier_id) ||
    !SUBSCRIPTION_BILLING_CYCLES.has(billing_cycle)
  ) {
    throw new Error("Invalid subscription checkout request.");
  }

  try {
    return await authenticated_api.post(
      `/subscriptions/checkout/`,
      { tier_id, billing_cycle });
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};
